import * as React from 'react';
import {Card, Stack, Typography} from '@mui/material';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import {useNavigate} from "react-router-dom";

export default function FAQBox() {
    const { mode } = useDarkMode();
    const navigate = useNavigate();
    return (
        <Card class={'sideMenuCard'} style={{backgroundColor: mode.settings.cardBackgroundColor, cursor : 'pointer'}}
            onClick={() => navigate('/faq')}
        >
            <Stack direction="column" justifyContent="left" alignItems="center" spacing={2} padding={1}>
                <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} sx={{marginTop:'7px'}}>
                    <Typography variant={'subtitle2'} sx={{color:'#79A00B'}}>Voir la FAQ</Typography>
                </Stack>
            </Stack>
            <div id={"id_target_container"}></div>
        </Card>
    )
}
